export default __webpack_public_path__ + "static/media/flag_bw.b752320e.svg";